import { render, staticRenderFns } from "./SolidWorks.vue?vue&type=template&id=857707da&scoped=true&"
import script from "./SolidWorks.vue?vue&type=script&lang=js&"
export * from "./SolidWorks.vue?vue&type=script&lang=js&"
import style0 from "./SolidWorks.vue?vue&type=style&index=0&id=857707da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857707da",
  null
  
)

export default component.exports